/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VacationRequestsControllerUpdateByIdRequest { 
    startDate?: string;
    endDate?: string;
    /**
     * Días específicos seleccionados (modo selección múltiple)
     */
    selectedDates?: Array<string>;
    employeeComments?: string;
    manualApproverId?: number;
    manualApproverReason?: string;
    /**
     * Solicita adelanto: los días que no cubre el saldo actual se cobran al próximo período
     */
    isAdvance?: boolean;
    /**
     * Motivo del adelanto (obligatorio cuando isAdvance es true)
     */
    advanceReason?: string;
}

